import {Component, ElementRef, ViewChild, AfterViewInit, OnDestroy, OnInit, ChangeDetectorRef} from '@angular/core';
import { ScrollPanel } from 'primeng/primeng';
import { TokenService, AuthUser } from './core/auth';
import { TitleService } from './title.service';
import {ActivatedRoute, ActivationEnd, NavigationEnd, ResolveStart, Router, RoutesRecognized} from '@angular/router';
import {filter, map} from 'rxjs/operators';

@Component({
    selector: 'app-backoffice',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {

    darkTheme = true;
    menuMode = 'static';
    topbarMenuActive: boolean;
    overlayMenuActive: boolean;
    staticMenuDesktopInactive: boolean;
    staticMenuMobileActive: boolean;
    layoutMenuScroller: HTMLDivElement;
    menuClick: boolean;
    topbarItemClick: boolean;
    activeTopbarItem: any;
    resetMenu: boolean;
    menuHoverActive: boolean;

    displayActivationDialog: boolean = false;
    activationDialogMode: string;
    activationDialogToken: string;

    authUser = this.token.whoAmI();

    constructor(
        public token: TokenService,
        private titleService: TitleService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private cdRef: ChangeDetectorRef
    ) {}

    @ViewChild('layoutMenuScroller') layoutMenuScrollerViewChild: ScrollPanel;

    ngOnInit() {
        this.initActivationDialog();
    }

    initActivationDialog() {
        const params = this.getQueryParams();
        if (params['m'] && (params['m'] === 'activate' || params['m'] === 'recover') && params['t']) {
            this.displayActivationDialog = true;
            this.activationDialogMode = params['m'];
            this.activationDialogToken = params['t'];
        }
        this.cdRef.detectChanges();
    }

    getQueryParams() {
        const params = {};
        if (window.location.href.indexOf('?') > 0 && window.location.href.indexOf('?') < window.location.href.length) {
            const searchParams = new URLSearchParams(window.location.href.substring(window.location.href.indexOf('?') + 1));
            if (searchParams.get('m')) {
                params['m'] = searchParams.get('m');
            }
            if (searchParams.get('t')) {
                params['t'] = searchParams.get('t');
            }
        }
        return params;
    }

    ngAfterViewInit() {
        if (this.layoutMenuScrollerViewChild) {
            setTimeout(() => { this.layoutMenuScrollerViewChild.moveBar(); }, 100);
        }
        this.titleService.init();
    }
    hasValidUser() {
        const valid = this.authUser != null
            ? !this.authUser.isTokenExpired()
            : false;
        return valid;
    }
    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (!this.menuClick) {
            if (this.isHorizontal() || this.isSlim()) {
                this.resetMenu = true;
            }

            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }

            this.menuHoverActive = false;
        }

        this.topbarItemClick = false;
        this.menuClick = false;
    }

    onMenuButtonClick(event) {
        this.menuClick = true;
        this.topbarMenuActive = false;

        if (this.isOverlay()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }
        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
        }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
        this.resetMenu = false;

        if (!this.isHorizontal()) {
            setTimeout(() => { this.layoutMenuScrollerViewChild.moveBar(); }, 500);
        }
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    isHorizontal() {
        return this.menuMode === 'horizontal';
    }

    isSlim() {
        return this.menuMode === 'slim';
    }

    isOverlay() {
        return this.menuMode === 'overlay';
    }

    isStatic() {
        return this.menuMode === 'static';
    }

    isMobile() {
        return window.innerWidth < 1025;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    hideOverlayMenu() {
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    changeTheme(theme) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
        themeLink.href = 'assets/theme/theme-' + theme + '.css';
        const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');
        layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';

        if (theme.indexOf('dark') !== -1) {
            this.darkTheme = true;
            localStorage.setItem('theme', 'dark');
        } else {
            this.darkTheme = false;
            localStorage.setItem('theme', 'light');
        }
    }

}
